import common from "../common";
import GelButton from "../ui/gel/GelButton";
import GelScene from "../ui/gel/GelScene";

export default class HelpScene extends GelScene {
    constructor() {
        super();

        this._panel = null;
        this._pageIndicator = null;
        this._pageIndex = 0;
        this._pages = [
            {image: "ui_help_image1", text: "Click to select the correct answer"},
            {image: "ui_help_image2", text: "Click and drag the correct answers into place"},
            {image: "ui_help_image3", text: "Enter the missing number. You can use your keyboard or turn on the on-screen keypad."}
        ];
    }

    init() {
        super.init();

        const bg = new PIXI.Sprite(P3.assets.texture("ui_results_bg1"));
        bg.width = common.STAGE_WIDTH;
        this.addChild(bg);

        this.initPanel();
        this.initPageIndicator();

        this.initTitle("How to Play");

        this.initBackButton(GelButton.TAB_INDEX_LEVEL_0);
        this.initMuteButton(GelButton.TAB_INDEX_LEVEL_0 + 1);
        this.initSettingsButton(GelButton.TAB_INDEX_LEVEL_0 + 2);
        this.initLeftButton(GelButton.TAB_INDEX_LEVEL_1);
        this.initRightButton(GelButton.TAB_INDEX_LEVEL_1 + 1);

        this.setPage(0);
    }

    show() {
        super.show();

        this.setPage(this._pageIndex);
    }

    animateIn() {
        if (this.parent === null) return;

        super.animateIn();

        let to = this._panel.y;
        this._panel.y += 460;
        new P3.utils.TWEEN.Tween(this._panel, this._tweens)
            .to({y: to}, 340)
            .easing(P3.utils.TWEEN.Easing.Quadratic.Out)
            .delay(140)
            .start();


        this._panel.scale.set(0);
        new P3.utils.TWEEN.Tween(this._panel.scale, this._tweens)
            .to({x: 1, y: 1}, 340)
            .easing(P3.utils.TWEEN.Easing.Quadratic.Out)
            .delay(140)
            .onStart(() => {
                this._panel.visible = true;
            })
            .onComplete(() => {
                new P3.utils.TWEEN.Tween(this._panel.left, this._tweens)
                    .to({x: -this._panel.image.width * 0.5}, 440)
                    .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                    .start();

                new P3.utils.TWEEN.Tween(this._panel.right, this._tweens)
                    .to({x: this._panel.image.width * 0.5}, 440)
                    .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                    .onUpdate(() => {
                        this._panel.inner.mask.width = Math.abs(this._panel.left.x - this._panel.right.x);
                    })
                    .onComplete(() => {
                    })
                    .start();
            })
            .start();

        for (let i = 0; i < this._pageIndicator.children.length; ++i) {
            const blip = this._pageIndicator.children[i];

            blip.alpha = 0;
            new P3.utils.TWEEN.Tween(blip, this._tweens)
                .to({alpha: 1}, 220)
                .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                .delay(620 + i * 40)
                .onStart(() => {
                    blip.visible = true;
                })
                .start();
        }
    }

    initPanel() {
        this._panel = new PIXI.Container();
        this._panel.position.set(common.STAGE_WIDTH * 0.5, 420);
        this._panel.visible = false;
        this.addChild(this._panel);

        this._panel.inner = new PIXI.Container();
        this._panel.addChild(this._panel.inner);

        this._panel.image = new PIXI.mesh.NineSlicePlane(P3.assets.texture("ui_help_scroll_bg_50pcwidth"), 180, 20, 180, 20);
        this._panel.image.width = 800;
        this._panel.image.height = 480;
        this._panel.image.pivot.set(this._panel.image.width * 0.5, this._panel.image.height * 0.5);
        this._panel.inner.addChild(this._panel.image);

        this._panel.content = new PIXI.Sprite(PIXI.Texture.EMPTY);
        this._panel.content.position.set(0, -44);
        this._panel.content.anchor.set(0.5);
        this._panel.inner.addChild(this._panel.content);

        this._panel.label = new PIXI.extras.BitmapText("How to play description goes here", {font: "30px BBC Reith Sans", align: "center"});
        this._panel.label.position.set(0, 178);
        this._panel.label.anchor.set(0.5);
        this._panel.label.tint = 0x2B365A;
        this._panel.label.maxWidth = 680;
        this._panel.inner.addChild(this._panel.label);

        this._panel.left = new PIXI.Sprite(P3.assets.texture("ui_help_scroll_fg"));
        this._panel.left.position.set(-34, 0);
        this._panel.left.anchor.set(0.5);
        this._panel.addChild(this._panel.left);

        this._panel.right = new PIXI.Sprite(P3.assets.texture("ui_help_scroll_fg"));
        this._panel.right.position.set(34, 0);
        this._panel.right.anchor.set(0.5);
        this._panel.addChild(this._panel.right);

        if (common.renderer instanceof PIXI.WebGLRenderer) {
            this._panel.inner.mask = new PIXI.Sprite(PIXI.Texture.WHITE);
            this._panel.inner.mask.x = this._panel.image.width * 0.5;
            this._panel.inner.mask.width = Math.abs(this._panel.left.x - this._panel.right.x);
            this._panel.inner.mask.height = this._panel.image.height;
            this._panel.inner.mask.anchor.set(0.5, 0);
            this._panel.inner.mask.tint = 0xFF0000;
            this._panel.image.addChild(this._panel.inner.mask);
        } else {
            this._panel.inner.mask = new PIXI.Graphics();
            //this._panel.inner.mask.x = this._panel.image.width * 0.5;
            this._panel.inner.mask.beginFill(0xFF0000, 1);
            this._panel.inner.mask.drawRect(
                -Math.abs(this._panel.left.x - this._panel.right.x) * 0.5,
                -this._panel.image.height * 0.5,
                Math.abs(this._panel.left.x - this._panel.right.x),
                this._panel.inner.height
            );
            this._panel.inner.mask.endFill();
            this._panel.inner.addChild(this._panel.inner.mask);
        }
    }

    initPageIndicator() {
        this._pageIndicator = new PIXI.Container();
        this._pageIndicator.position.set(common.STAGE_WIDTH * 0.5, P3.View.height - 54);
        this.addChild(this._pageIndicator);

        const spacing = 100;

        for (let i = 0; i < this._pages.length; ++i) {
            const blip = new PIXI.Container();
            blip.position.set(spacing * i - spacing * (this._pages.length - 1) * 0.5, 0);
            blip.visible = false;
            this._pageIndicator.addChild(blip);

            blip.off = new PIXI.Sprite(P3.assets.texture("ui_icon_pagination_off"));
            blip.off.anchor.set(0.5);
            blip.addChild(blip.off);

            blip.on = new PIXI.Sprite(P3.assets.texture("ui_icon_pagination_on"));
            blip.on.anchor.set(0.5);
            blip.on.visible = false;
            blip.addChild(blip.on);
        }
    }

    setPage(index) {
        const page = this._pages[index];

        this._panel.content.texture = P3.assets.texture(page.image);
        this._panel.label.text = page.text;

        this._rightButton.visible = index < this._pages.length - 1;
        this._leftButton.visible = index > 0;

        for (let i = 0; i < this._pageIndicator.children.length; ++i) {
            const blip = this._pageIndicator.getChildAt(i);
            blip.on.visible = i === index;
        }
    }

    onLeftButtonClick(event) {
        --this._pageIndex;
        if (this._pageIndex < 0) this._pageIndex = 0;

        this.setPage(this._pageIndex);
    }

    onRightButtonClick(event) {
        ++this._pageIndex;
        if (this._pageIndex >= this._pages.length) this._pageIndex = this._pages.length - 1;

        this.setPage(this._pageIndex);
    }
}